import type { components } from '@pba/types-openapi-client';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type CommentResponse = components['schemas']['Comment'];

type CreateCommentRequest = {
  content_object: {
    attachments?: Array<{ id: string }>;
    html_content?: string;
    parent_id: string;
    text_content?: string;
  };
};

export const createComment = async (data: CreateCommentRequest) =>
  apiClient.post<CommentResponse, ApiClientResponse<CommentResponse>>(routes.contentObjects.comment.create, data);
